import React, {FC} from 'react';

interface Icon {
	className?: string
}

export const Check: FC<Icon> = ({className}) => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
		<rect width='24' height='24' rx='12' fill='currentColor' />
		<path
			d='M7.5364 11.73C7.18492 11.3785 6.61508 11.3785 6.2636 11.73C5.91213 12.0814 5.91213 12.6513 6.2636 13.0027L9.53043 16.2696C9.8819 16.621 10.4517 16.621 10.8032 16.2696L18.5364 8.5364C18.8879 8.18492 18.8879 7.61508 18.5364 7.2636C18.1849 6.91213 17.6151 6.91213 17.2636 7.2636L10.1668 14.3604L7.5364 11.73Z'
			fill='white' />
	</svg>
);

export const Plus: FC<Icon> = ({className}) => (
	<svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
		<path d='M0.952267 7.95227H6.04773V13.0477C6.04773 13.5656 6.47375 14 7 14C7.52625 14 7.95227 13.5656 7.95227 13.0477V7.95227H13.0477C13.5656 7.95227 14 7.52625 14 7C14 6.47375 13.5656 6.04773 13.0477 6.04773H7.95227V0.952267C7.95227 0.434368 7.52625 0 7 0C6.47375 0 6.04773 0.434368 6.04773 0.952267V6.04773H0.952267C0.434368 6.04773 0 6.47375 0 7C0 7.52625 0.434368 7.95227 0.952267 7.95227Z' fill='#1C3133' />
	</svg>
);
